import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/error.entity";
import { HumanRanking, Target } from "../../../../domain/repositories/dashboard.repository";
import DateDto from "../../../dto/date.dto";
import di from "../../../../dependency_injection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import HumanRankingDto from "../../../dto/human_ranking.dto";

const getTopAndBottomAgentsApiImpl = async (_: {
    clientId?: string, startDate: Date, endDate: Date
}): Promise<Either<ErrorEntity, { worst: HumanRanking[], best: HumanRanking[] }>> => {
    try {
        let relativeUrl = "/stats/human-agents-ranking-divided?";
        const { startDate, endDate, aiAgentId, callTypeId, humanAgentId, operationId }: { startDate: Date, endDate: Date, operationId?: string, humanAgentId?: string, aiAgentId?: string, callTypeId?: string, } = _;
        if (startDate) relativeUrl += `start_date=${DateDto.toServer(startDate)}&`
        if (endDate) relativeUrl += `end_date=${DateDto.toServer(endDate)}&`
        if (aiAgentId) relativeUrl += `agent_id=${aiAgentId}&`
        if (callTypeId) relativeUrl += `call_type=${callTypeId}&`
        if (humanAgentId) relativeUrl += `human_agent_id=${humanAgentId}&`
        if (operationId) relativeUrl += `operation_id=${operationId}&`
        relativeUrl = relativeUrl.slice(0, -1); // remove the last '&'
        const response = await di.get<HostApi>(HostApiName).get(relativeUrl, {
            contentType: 'application/json',
        });
        const best = response.top_performers.map((item: any) => HumanRankingDto.fromJSON(item));
        const worst = response.bottom_performers.map((item: any) => HumanRankingDto.fromJSON(item));
        const sortedWorst = worst.sort((a: HumanRanking, b: HumanRanking) => b.rankingPosition - a.rankingPosition);
        console.log({ best, worst });
        return right({
            best, worst: sortedWorst,
        });

    } catch (error) {
        return left(ErrorEntity.fromError(error));
    }
}

export default getTopAndBottomAgentsApiImpl;